import React, { useEffect, useMemo, useState } from "react";
import {VsiH4, VsiLgText} from "../styled/App.styled";

import { useVsiAppContext } from "../stores/VsiApp";
import NavCardFavs from "../components/NavCardFavs";
import NavCard from "../components/NavCard";
import { menuItems } from "../utils/routes";
import themeStyles from "../utils/themeStyles";
import { useTitleFromComponent } from "../utils/hooks";
import { Spinner } from "reactstrap";

const detailSupported = ['Host', 'Files', 'Device'];
const defaultFavs = [
    {
        "user": "",
        "client": "",
        "path": "/reports/storage/enterprise-summary",
        "context": "Storage",
        "title": "Enterprise Storage Summary",
        "params": [],
        "_id": "0",
        "__v": 0,
        "layout": [
            {
                "col": {
                    "xs": 12
                },
                "type": "description",
                "title": "Enterprise Storage Summary",
                "description": "View high-level summary of enterprise information."
            }
        ],
        "icon": "fa-chart-user"
    },

    {
        "user": "",
        "client": "",
        "path": "/reports/hosts/host-summary",
        "context": "Hosts",
        "title": "Enterprise Host Summary",
        "params": [],
        "_id": "0",
        "__v": 0,
        "icon": "fa-chart-user",
        "layout": [
            {
                "col": {
                    "xs": 12
                },
                "type": "description",
                "title": "",
                "description": "View a summary of information in grid and graphs format for Enterprise hosts."
            }
        ]
    },
    {
        "user": "",
        "client": "",
        "path": "/reports/virtual/virtual-summary",
        "context": "Virtual",
        "title": "Virtual Summary",
        "params": [],
        "_id": "0",
        "__v": 0,
        "layout": [
            {
                "col": {
                    "xs": 12
                },
                "type": "description",
                "title": "",
                "description": "View high-level summary of virtual machine information."
            }
        ],
        "icon": "fa-chart-user"
    },
    {
        "user": "",
        "client": "",
        "path": "/reports/business-unit/executive-overview",
        "context": "Business Unit",
        "title": "Executive Overview",
        "params": [],
        "_id": "0",
        "__v": 0,
        "icon": "fa-chart-pie",
        "layout": [
            {
                "col": {
                    "xs": 12
                },
                "type": "description",
                "title": "Executive Overview",
                "description": "View Business Unit Executive Overview."
            }
        ]
    }
];

export default function Home({title}) {
    const {
        theme,
        isTabletScreen,
        user: { favorites },
        client,
        getPeriodId,
        isGettingLatestPeriods,
        doPeriodsMatchReportContext,
    } = useVsiAppContext();

    const { name, clientId, _id } = client;

    useTitleFromComponent(`${name ?? 'N/A'} - Visual One Intelligence`);

    const leftSide = useMemo(() => {
        let clientFavorites = favorites.filter(favorite => favorite.client === _id);
        if (clientFavorites.length) {
            return [...clientFavorites].splice(0, Math.ceil(clientFavorites.length / 2));
        } else {
            return [...defaultFavs].splice(0, Math.ceil(defaultFavs.length / 2));
        }
    }, [favorites, _id]);

    const rightSide = useMemo(() => {
        let clientFavorites = favorites.filter(favorite => favorite.client === _id);
        if (clientFavorites.length) {
            return [...clientFavorites].splice(Math.ceil(clientFavorites.length / 2), clientFavorites.length - 1);
        } else {
            return [...defaultFavs].splice(Math.ceil(defaultFavs.length / 2), defaultFavs.length - 1);
        }
    }, [favorites, _id]);

    return (
        <div>
            <VsiH4>{title} <i><VsiLgText className={"ps-1"}>{client.name}</VsiLgText></i></VsiH4>
            {!isGettingLatestPeriods && doPeriodsMatchReportContext ? (
              <VsiLgText>
                Click a favorited report to dive deeper or select the <i
                className={`fa-solid fa-bookmark report-util-icon px-1`}
                style={{color: themeStyles[theme].vsiPupil}}/> icon to remove the report from your
                favorites.
            </VsiLgText>
            ) : (
              <VsiLgText>
                  Getting your favorites... <Spinner size="sm" color="success" />
              </VsiLgText>
            )}

            {!isGettingLatestPeriods && doPeriodsMatchReportContext ? (
              <div className={`mb-2 d-flex justify-content-around flex-${isTabletScreen ? 'column' : 'row'}`}>
                <div className={`w-${isTabletScreen ? '100' : '50'} pe-2`}>
                    {leftSide.map((item, index) => {
                        const contextIcon = menuItems.find(menu => menu.context.toLowerCase() === item.context.toLowerCase())?.icon ?? '';
                        return (
                            <div
                                key={`nav-card-${item.title
                                    .toLowerCase()
                                    .split(" ")
                                    .join("-")}-${index}`}>
                                <NavCardFavs
                                        {...item}
                                        contextIcon={contextIcon}
                                        clientId={clientId}
                                        periodId={getPeriodId(item.context)}
                                    />
                            </div>
                        );
                    })}
                </div>
                <div className={`w-${isTabletScreen ? '100' : '50'} ps-2`}>
                    {rightSide.map((item, index) => {
                        const contextIcon = menuItems.find(menu => menu.context.toLowerCase() === item.context.toLowerCase())?.icon ?? '';
                        return (
                            <div
                                key={`nav-card-${item.title
                                    .toLowerCase()
                                    .split(" ")
                                    .join("-")}-${index}`}>
                                 <NavCardFavs
                                        {...item}
                                        contextIcon={contextIcon}
                                        clientId={clientId}
                                        periodId={getPeriodId(item.context)}
                                    />
                            </div>

                        );
                    })}
                </div>
            </div>
              ) : null}
        </div>
    )
}
